import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { InvoiceService } from "src/app/_services/invoice.service";
import { PosService } from "src/app/_services/posService";
import { S3Service } from "src/app/_services/s3.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-credit-note-detail",
  templateUrl: "./credit-note-detail.component.html",
  styleUrls: ["./credit-note-detail.component.scss"],
})
export class CreditNoteDetailComponent implements OnInit {
  po: any;
  responseData: any;
  isError: any;
  isEmpty = false;
  loading = true;
  displayName: any;
  credit_note: any;
  utrExist = false;
  paymentDateExist = false;
  paymentAdviceExist = false;
  paymentDueDateExist = false;
  isCondensed = false;
  debitNoteExist = false;
  currentLayout = {
    isCondensed: true,
  };
  showing = false;
  showStatusInfo = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private invoiceService: InvoiceService,
    private posService: PosService,
    private s3Service: S3Service,
    private authService: AuthService,
  ) {}

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  statusInfo() {
    this.showing = true;
    this.showStatusInfo = true;
  }

  closeStatusInfo() {
    this.showing = false;
    this.showStatusInfo = false;
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    //const code = this.route.snapshot.params["barcode"];
    const userData = {
      sortConfig: {
        field: "updateTime",
        order: "desc",
      },
      pageSize: 50,
      pageNo: 1,
      filters: [
        {
          key: "supplierCodesToRestrict",
          value: localStorage.getItem("vendorCode"),
        },
        {
          key: "barcode",
          value: this.route.snapshot.params["barcode"],
        },
      ],
      sellercode: this.authService.getSellerCode(),
      isExport: false,
      linkFilters: [],
      isAP: true,
    };

    this.posService.fetchCNDN(userData).subscribe(
      (res) => {
        this.loading = false;
        this.responseData = res;
        console.log(this.responseData, "responseData");

        this.credit_note = this.responseData.data.list[0];
        if (typeof this.credit_note.statuses === "undefined") {
          this.credit_note.statuses = "";
        }
        // if (this.responseData.pos.length !== 0) {
        //   console.log('You did it');
        //   this.pod = this.responseData;
        //   console.log(this.pod);
        // } else {
        //   this.isEmpty = true;
        //   //console.log('Error Here');
        // }
        //console.log(res);

        if (this.credit_note.barcode) {
          this.s3Service
            .getFile(`${environment.uploadedPdfsS3Prefix}/${this.credit_note.barcode}.pdf`)
            .subscribe({
              next: (response: any) => {
                this.credit_note.file_link = `${environment.dataUrl}appprxy?path=${encodeURIComponent(response.data.url)}`;
              },
              error: () => {},
            });
        }

        if (this.checkObjectKeyExist(this.credit_note, "rejections", "rej1") === undefined) {
          Object.assign(this.credit_note, { rejection1: false });
        } else {
          Object.assign(this.credit_note, { rejection1: true });
        }

        if (this.checkObjectKeyExist(this.credit_note, "rejections", "rej2") === undefined) {
          Object.assign(this.credit_note, { rejection2: false });
        } else {
          Object.assign(this.credit_note, { rejection2: true });
        }

        if (this.checkObjectKeyExist(this.credit_note, "gst_reconciled") === undefined) {
          Object.assign(this.credit_note, { gst_exist: false });
        } else {
          Object.assign(this.credit_note, { gst_exist: true });
        }

        if (typeof this.credit_note.utr_number !== "undefined" && typeof this.credit_note.utr_number && this.credit_note.utr_number !== "") {
          this.utrExist = true;
        }

        if (typeof this.credit_note.payment_date !== "undefined" && this.credit_note.payment_date !== null && this.credit_note.payment_date !== "") {
          this.paymentDateExist = true;
        }

        if (typeof this.credit_note.payment_due_date !== "undefined" && this.credit_note.payment_due_date !== null && this.credit_note.payment_due_date !== "") {
          this.paymentDueDateExist = true;
        }

        if (typeof this.credit_note.debit_note_attachment !== "undefined" && this.credit_note.debit_note_attachment !== null && this.credit_note.debit_note_attachment !== "") {
          this.debitNoteExist = true;
        }

        if (typeof this.credit_note.payment_advice_attachment !== "undefined" && this.credit_note.payment_advice_attachment !== null && this.credit_note.payment_advice_attachment !== "") {
          this.paymentAdviceExist = true;
        }

        console.log(this.credit_note);
      },
      (error) => {}
    );
  }

  checkObjectKeyExist(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj);
  }
}
